import { useRef, useEffect, useState } from 'react';
import { localeMap, textLink } from '../common';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type HeaderType = {
    top?: number;
    width?: string;
    borderRadius?: string;
    isBanner?: boolean;
    isMM100?: boolean;
    bodyClick?: boolean;
};

const HeaderTitle = ({
    isBanner = false,
    svgClick,
    svgOver,
    isMM100 = false,
}: {
    isBanner: boolean;
    svgClick: () => void;
    svgOver: () => void;
    isMM100: boolean;
}) => {
    const { isMobile } = useGlobal();

    return (
        <div className="title">
            You Could Apply for{' '}
            <span className="bold-title" onClick={svgClick} style={isBanner && isMobile ? { textDecoration: 'underline' } : {}}>
                30% Tax Credit*,
            </span>
            {isBanner && <span className="svg-ani" onClick={svgClick} onMouseEnter={svgOver}></span>}
            When You Install {isMM100 ? 'Power Kits' : 'DELTA Pro'} as a Home Power Solution
            {isMobile && <span className="mobile-icon" onClick={textLink}></span>}
        </div>
    );
};

export default function IRAHeader({ top, width = '100%', borderRadius = '0px', isBanner = false, isMM100 = false, bodyClick = false }: HeaderType) {
    const { useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const ref: any = useRef();
    const [showFooter, setShowFooter] = useState(false);

    useEffect(() => {
        if (!isBanner) {
            const dom: HTMLDivElement = ref.current;
            if (top || top === 0) {
                dom.style.top = `${top}px`;
            } else {
                const navDom = document.querySelector('.product_naver') as HTMLDivElement;
                if (navDom) {
                    navDom.style.top = `${dom.clientHeight}px`;
                }
            }
        }
    }, [top]);

    const langItem = localeMap[locale as keyof typeof localeMap] || localeMap.us;

    return (
        <div className={`${styles.IRAHeader} IRAHeader`} ref={ref} style={{ width, borderRadius, cursor: bodyClick ? 'pointer' : '' }}>
            <div
                className={`${isMobile ? 'mobile-box' : 'pc-box'} ${isBanner && isMobile ? 'mobile-banner_ira' : ''} ${
                    isBanner && !isMobile ? 'pc-banner_ira' : ''
                } ${showFooter && !isMobile ? 'show-ira' : ''} ${showFooter && isMobile ? 'show-ira__mobile' : ''}`}
                style={{ borderRadius }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onMouseLeave={() => {
                    if (!isMobile) {
                        setShowFooter(false);
                    }
                }}
            >
                <div className="ira-content" onClick={() => bodyClick && textLink()}>
                    <HeaderTitle
                        isBanner={isBanner}
                        svgOver={() => {
                            if (!isMobile) {
                                setShowFooter(true);
                            }
                        }}
                        svgClick={() => {
                            if (isMobile && isBanner) {
                                setShowFooter(true);
                            }
                        }}
                        isMM100={isMM100}
                    />
                    <div className="learn-more" onClick={textLink}>
                        {!isMobile && (
                            <>
                                <span className="text">{langItem.learnMore}</span>
                                <span className="svg-icon"></span>
                            </>
                        )}
                    </div>
                </div>
                {isBanner && (
                    <>
                        <div className="ira-footer">
                            <div className="ira-title">{langItem.footerTitle}</div>
                            <div className="ira-desc">{langItem.desc}</div>
                            <div className="ira-date">{langItem.dateText}</div>
                        </div>
                        {isBanner && isMobile && (
                            <div
                                className="collapse-svg"
                                onClick={() => {
                                    setShowFooter(false);
                                }}
                            ></div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
